import { httpClientPrivate, httpClientPrivateMultipart } from "./axios";
import { accessToken, accessToken2 } from "./token";

export const updateMediaApi = async (body) => {
  return await httpClientPrivateMultipart.put(`/media/update`, body, accessToken2());
}
export const getMediaApi = async (body) => {
  return await httpClientPrivate.post(`/media/get`, body, accessToken());
}